import { SegmentedControl } from "@mantine/core";
import { TDimension } from "@mctypes/global.types";
import React from "react";
import { DimensionEnums } from "@mcapps/shared/sharedConstants";

const DimensionSelector: React.FC<{
  activeDimension: TDimension;
  setActiveDimension: (dimension: TDimension) => void;
}> = ({ activeDimension, setActiveDimension }) => {
  return (
    <SegmentedControl
      aria-label="Velg dimensjon"
      color="lightgray.8"
      value={activeDimension}
      onChange={(val) => setActiveDimension(val as TDimension)}
      style={{ width: 150 }}
      data={[
        { value: DimensionEnums.TWODIMENSION, label: DimensionEnums.TWODIMENSION },
        { value: DimensionEnums.THEREEDIMENSION, label: DimensionEnums.THEREEDIMENSION },
      ]}
    />
  );
};

export default DimensionSelector;
